export default __webpack_public_path__ + "static/media/Group 1389.be982550.svg";